import { MAX_AVATARS_DESKTOP } from "./const";
import { cn } from "@punchup/utils/cn";

interface Props {
  comedianNames: string[];
  hide?: boolean;
  className?: string;
}

/*
 * a component that displays the name of multiple comedians concatenated with proper formatting
 */
export function ComedianNames({
  comedianNames,
  hide = false,
  className,
}: Props) {
  if (hide) return null;

  const getComedianSeparator = (
    idx: number,
    arr: string[],
    maxAvatars: number,
    comedianCount: number
  ) => {
    // Last comedian
    if (idx === arr.length - 1) {
      return comedianCount > maxAvatars ? " & Others" : "";
    }

    // Second-to-last comedian when showing all comedians
    if (idx === arr.length - 2 && comedianCount <= maxAvatars) {
      return " & ";
    }

    // All other cases: show comma
    return ", ";
  };

  const comedianNamesString = comedianNames
    .map(
      (name, index, arr) =>
        `${name}${getComedianSeparator(index, arr, MAX_AVATARS_DESKTOP, comedianNames.length)}`
    )
    .join("");

  return (
    <div className={cn("line-clamp-2 md:line-clamp-1", className)}>
      <p className="text-primary-blue font-bold text-lg">
        {comedianNamesString}
      </p>
    </div>
  );
}
